/**
 * Created by eriksundqvist on 11/10/16.
 */
export default class InvoiceUserEntity {

  constructor (
    travel,
    co,
    street,
    zip,
    city,
    country,
    invoiceId,
    userId,
    allowance,
    taxkeyId,
    total,
    firstName,
    lastName,
    accountClearingNumber,
    accountNumber,
    salaryPayedDate,
    expressPayment,
    taxkeyName,
    saveVacationPay,
    saveItp,
    itpRate,
    calculation,
    gross,
    net,
    taxkeys
  ) {
    this.travel = travel;
    this.co = co;
    this.street = street;
    this.zip = zip;
    this.city = city;
    this.country = country;
    this.invoiceId = invoiceId;
    this.userId = userId;
    this.allowance = allowance;
    this.taxkeyId = taxkeyId;
    this.total = total;
    this.firstName = firstName;
    this.lastName = lastName;
    this.accountClearingNumber = accountClearingNumber;
    this.accountNumber = accountNumber;
    this.salaryPayedDate = salaryPayedDate;
    this.expressPayment = expressPayment;
    this.taxkeyName = taxkeyName;
    this.saveVacationPay = saveVacationPay;
    this.saveItp = saveItp;
    this.itpRate = itpRate;
    this.calculation = calculation;
    this.gross = gross;
    this.net = net;
    this.taxkeys = taxkeys;
  }
}



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/invoices/invoice-user-entity.js
 **/